/*
 * TAKEDA CONFIDENTIAL – Highly Restricted: Do not distribute without prior approval
 *
 * © Copyright (2026) Takeda. All Rights Reserved
 */

export type MsalAuthConfig = {
  clientId: string;
  tenantId: string;
  authority: string;
  redirectUri: string;
};

export enum LoginType {
  TakedaId = 'takeda_id',
  DocCheck = 'doc_check',
  Unauthenticated = 'unauthenticated',
}

export type TakedaIdError = {
  invalidCountry?: boolean;
  wrongCountry?: boolean;
};

export enum TakedaIdErrorType {
  InvalidCountry = 'invalid_country',
  InvalidUser = 'invalid_user',
  RequestError = 'request_error',
  WrongCountry = 'wrong_country',
}

export enum DocCheckErrorType {
  RequestError = 'request_error',
}

export type ErrorTranslations = {
  reason: string;
  contact?: string;
};

export type UserId = string | number;
